export default "__VITE_ASSET__889413ce__"